/* eslint-disable */
import { Component } from 'react'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'

class DashboardGraph extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: Date.now(),
    }
  }

  getTimeStamp = (epochSeconds) => {
    var date = new Date(epochSeconds * 1000)
    return date.toLocaleString()
  }

  render() {
    const CustomTooltip = ({ active, payload, label }) => {
      if (active && payload && payload.length) {
        return (
          <div
            style={{
              width: 'fit-content',
              padding: '5px',
              height: 'fit-content',
              border: 'solid 1px #d3d3d3',
              textAlign: 'center',
              backgroundColor: '#ebecf0',
            }}
          >
            <div
              style={{
                fontFamily: 'Montserrat',
                fontSize: '16',
                padding: '1px',
              }}
            >{`${this.getTimeStamp(label)}`}</div>
            <div
              style={{
                fontFamily: 'Montserrat',
                fontSize: '16',
                padding: '1px',
              }}
            >{`${Math.round(payload[0].value)}%`}</div>
          </div>
        )
      }
      return null
    }

    const data = () => {
      let dArr = []
      for (let i = 0; i < this.props.yArray.length; i++) {
        let res = {}
        res['x'] = this.props.xArray[i]
        res['y'] = this.props.yArray[i]
        dArr[i] = res
      }
      return dArr
    }
    return (
      <ResponsiveContainer width="100%" height="110%">
        <LineChart data={data()}>
          <XAxis dataKey="x" tick={false} />
          <YAxis
            reversed={false}
            tickCount={3}
            style={{ fontFamily: 'Lucida Console, monospace', fontSize: 10 }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Line
            type="monotone"
            dataKey="y"
            stroke="#000000"
            strokeWidth={2}
            dot={false}
          />
          <CartesianGrid stroke="#d3d3d3" strokeDasharray="1" />
        </LineChart>
      </ResponsiveContainer>
    )
  }
}
export default DashboardGraph
